import React from 'react'

import { ReactComponent as J4CLogo } from './../j4clogo.svg'

 const LoadingJ4C = () => {
    return (<section className='grid h-full place-items-center'> 
                <J4CLogo className='animate-ping' width={128} />
            </section>)
}

  export default LoadingJ4C